import { checkCoordinates, Coordinate } from "./api";

export async function runCrossMatch() {
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const usedRange = sheet.getUsedRange();
      usedRange.load("values");
      await context.sync();

      const allValues = usedRange.values as any[][];
      if (!allValues || allValues.length < 2) {
        console.warn("⚠️ No data found in sheet.");
        return;
      }

      const headers = allValues[0].map((h: any) => h?.toString().trim().toLowerCase());

      const cadastralIdx = headers.indexOf("cadastral_reference");
      const latIdx = headers.indexOf("reolyzer_coord_lat");
      const lngIdx = headers.indexOf("reolyzer_coord_lng");

      if (cadastralIdx === -1 || latIdx === -1 || lngIdx === -1) {
        console.error("❌ Required columns not found (cadastral_reference, coord_lat, coord_lng).");
        return;
      }

      // Build coordinate objects from rows
      const coords: Coordinate[] = allValues
        .slice(1) // skip header row
        .filter((row) => row[cadastralIdx] && row[latIdx] && row[lngIdx])
        .map((row) => ({
          cadastral_reference: row[cadastralIdx].toString(),
          lat: parseFloat(row[latIdx]),
          lng: parseFloat(row[lngIdx]),
        }));

      console.log("📌 Extracted coordinates:", coords);

      if (coords.length === 0) {
        console.warn("⚠️ No valid rows with coordinates.");
        return;
      }

      // Call API
      const zones = await checkCoordinates(coords);
      console.log("✅ Zones from API:", zones);

      // Ensure headers for new columns exist
      const newHeaders = ["provider_names", "provider_emails"];
      newHeaders.forEach((h) => {
        if (!headers.includes(h)) {
          headers.push(h);
          allValues[0].push(h);
        }
      });

      // Ensure every row has the same number of columns as the header
      const totalCols = allValues[0].length;
      for (let r = 1; r < allValues.length; r++) {
        while (allValues[r].length < totalCols) {
          allValues[r].push("");
        }
      }

      const zoneMap = new Map(
        zones.map((z: any) => [z.cadastral_reference, z])
      );

      // Append values to each row
      for (let r = 1; r < allValues.length; r++) {
        const cadastral = allValues[r][cadastralIdx]?.toString();
        const match = zoneMap.get(cadastral);
        
        allValues[r][headers.indexOf("provider_names")] = match?.provider_names || "";
        allValues[r][headers.indexOf("provider_emails")] = match?.provider_emails || "";
      }

      // Write updated data back into the worksheet
      const range = sheet.getRangeByIndexes(
        0,
        0,
        allValues.length,
        allValues[0].length
      );
      range.values = allValues;

      await context.sync();
      console.log("✅ Cross-match written back to sheet.");
    });
  } catch (err) {
    console.error("❌ Error in runCrossMatch:", err);
  }
}
